import React, { useState, useEffect } from "react";
import ReactMarkdown from "react-markdown";
import styled from "styled-components";
import { tint } from "../types/GeneralStyles";
import { WeekendVanDeKlant } from "./WeekendVanDeKlant";

let GlobalScore = 0;

export const ResultScreen = styled.div`
  ${(props) =>
    props.bgVisible &&
    props.bgColor &&
    `
    padding: 20px;
    background-color: ${tint(props.bgColor, 90)};
    border: 1px solid #ccc;
    border-radius: 10px;
  `}
  margin-bottom: 20px;
  text-align: left;
`;
const ResultCorrectAnswerStyle = styled.div`
  display: block;
  color: ${(props) => (props.txtColor ? props.txtColor : "white")};
  margin: 10px 0;
  background-color: ${(props) => (props.bgColor ? props.bgColor : "none")};
  padding: ${(props) => (props.bgColor ? "5px 10px 5px 4px" : "0")};
  border-radius: ${(props) => (props.bgColor ? "10px 10px 10px 10px" : "0")};
  @media print {
    page-break-inside: avoid;
  }
`;

const ResultAnwserValidation = styled.p`
  font-weight: bold;
  display: flex;
  margin: 0px 0.5ex 0 0;
  flex-direction: row;
  justify-content: space-between;
  @media print {
    page-break-inside: avoid;
  }
  i {
    background-color: white;
    padding: 2px;
    font-style: normal;
    border-radius: 6px;
    margin-right: 4px;
  }
`;

const QuizResultItemInformation = styled.p`
  font-size: 1rem;
  color: #3f4865;
  @media print {
    page-break-inside: avoid;
  }
`;
export const ResultTitle = styled.h3`
  font-size: 1.5em;
  margin: 0;
  color: ${(props) => (props.txtColor ? props.txtColor : "#ffffff")};;
  font-family: 'Arial', 'Helvetica Neue', 'Helvetica', 'Nimbus Sans L', 'Liberation Sans', 'Arimo', 'DejaVu Sans', 'Sans-Serif';
  text-align: left;
  bgColor={bgColor} txtColor={txtColor}
  background-color: ${(props) => (props.bgColor ? props.bgColor : "#031037")};
  margin: -10px -10px 10px -10px;
  padding: 10px;
  @media print {
    page-break-inside: avoid;
  }
`;
const QuizResultDivItem = styled.div``;
export const QuizResultDiv = styled.div`
  font-size: 1rem;
  border-radius: 5px;
  padding: 10px;
  background-color: ${(props) =>
    props.bgVisible === "true" ? "#e6f5ff" : "none"};
  border-width: 1px;
  border-style: solid;
  border-color: ${(props) =>
    props.borderInVisible === "true" ? "#FFFFFF00" : "#f2eff0"};
  border-radius: 10px;
  overflow: hidden;
  width: 100%;
  flex: 40%;
  @media (max-width: 1024px) {
    flex: 100%;
  }
  @media print {
    flex: 40%;
    page-break-inside: avoid;
  }
`;
export const QuizResultOl = styled.ol`
  display: flex;
  flex-direction: column;
  padding-left: 20px;
  margin-top: 0;
  @media print {
    page-break-inside: avoid;
  }
`;
export const QuizResultFlexContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: flex-start;
  gap: 10px;
  @media print {
    page-break-inside: avoid;
  }
`;

export const GeneralData = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media (max-width: 500px) {
    flex-direction: column;
  }
  @media print {
    flex-direction: row;
    page-break-inside: avoid;
  }
`;

export const ResultScore = ({
  score,
  scoreVisible,
  endTotalScore,
  startCalculation,
}) => {
  useEffect(() => {
    if (score) {
      GlobalScore += 1;
    }
  }, [score]);
  useEffect(() => {
    if (startCalculation) {
      GlobalScore = 0;
      // console.log("eerst uitgevoerd", GlobalScore);
    }
  }, [startCalculation]);
  // useEffect(() => {
  if (scoreVisible || endTotalScore) {
    // console.log("laatst uitgevoerd", GlobalScore);

    return (
      <>
        <WeekendVanDeKlant GlobalScore={GlobalScore} />
        <span>{GlobalScore}</span>
      </>
    );
  }
  // }, [scoreVisible,endTotalScore]);

  return null;
};

export const QuizResultH2 = styled.h2`
  color: #002b6c;
  margin-block-end: 0;
  @media print {
    page-break-inside: avoid;
  }
`;

export const QuizResultDescription = styled.div`
  font-size: 1rem;
  ${(props) =>
    props.bgColor &&
    `
  background-color: ${props.bgColor};`}
  margin: 0;
  border-radius: 10px;
  text-align: center;
  padding: 0px;
  color: white;
  @media print {
    page-break-inside: avoid;
  }
`;

export const QuizResultText = styled.span`
  font-size: 1rem;
  display: block;
  color: ${(props) => props.Color};
  background-color: ${(props) =>
    props.bgColor === "white" ? "white" : "none"};
  padding: ${(props) => (props.bgColor === "white" ? "5px 10px" : "0")};
  border-radius: ${(props) =>
    props.bgColor === "white" ? "10px 10px 0 0" : "0"};
  display: flex;
  img {
    max-width: 25%;
    margin: 0;
    padding: 0;
    padding-inline: 0;
  }
  @media print {
    page-break-inside: avoid;
  }
`;
export const QuizResultAnswer = styled.strong`
  font-weight: bold;
`;
export const QuizResultScore = styled.strong`
  font-size: 2rem;
  font-weight: bold;
`;
export const SimpleResultQuizResultScore = styled.p`
  font-size: 8rem;
  font-weight: bold;
  text-align: center;
  width: 100%;
  line-height: 0.5;
`;
export const SimpleResultQuizResultScoreSub = styled.strong`
  font-size: 2rem;
  font-weight: normal;
`;
export const QuizResultTitle = styled.h4`
  margin-bottom: 0;
  @media print {
    page-break-inside: avoid;
  }
`;
export const QuizEndResultText = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  // Mobile layout (screen display)
  @media (max-width: 500px) {
    flex-direction: column;
  }

  // Ensure desktop-like layout when exporting to PDF
  @media print {
    flex-direction: row !important;
    page-break-inside: avoid;
  }
`;
export const LittleText = styled.p`
  font-size: 0.8rem;
  color: #69788c;
  font-weight: light;
  margin: 0;
  margin-block-end: 0;
  text-align: ${(props) => (props.Align === "right" ? "right" : "left")};
  @media (max-width: 500px) {
    text-align: left;
  }
  @media print {
    page-break-inside: avoid;
  }
`;

export const ResultPogingen = ({ attempts, maximum_attempts }) => {
  const [attemptsWord, setAttemptsWord] = useState("");

  useEffect(() => {
    setAttemptsWord(attempts === 1 ? "poging" : "pogingen");
  }, [attempts]);

  const attemptWord = (attempts, attemptsWord) => {
    if (attempts === 0) {
      return "Geen pogingen ondernomen";
    }
    return `${attempts} ${attemptsWord}`;
  };

  return (
    <span>
      {`${attemptWord(attempts, attemptsWord)} van maximaal ${
        maximum_attempts === 0
          ? "onbeperkt aantal kansen"
          : maximum_attempts === 1
          ? `${maximum_attempts} kans`
          : `${maximum_attempts} kansen`
      }`}
    </span>
  );
};

export const resetQuiz = (databases, setDatabases, activeDatabase) => {
  // Haal de huidige dbName op uit sessionStorage
  const dbName = sessionStorage.getItem("currentSessionName") || "Leerling";

  // Verwijder de huidige sessionStorage
  sessionStorage.removeItem("currentSessionName");

  const deleteRequest = indexedDB.deleteDatabase(dbName);
  deleteRequest.onsuccess = () => {
    // Controleer of databases een array is voordat we filter() aanroepen
    if (Array.isArray(databases)) {
      setDatabases(databases.filter((db) => db !== dbName)); // Update de databases lijst
    } else {
      console.error("Databases is geen array:", databases);
    }

    // Controleer of activeDatabase overeenkomt met dbName, maar laadt de pagina altijd opnieuw
    if (activeDatabase === dbName) {
      sessionStorage.removeItem("currentSessionName");
    }

    // Voeg een korte vertraging toe voordat de pagina opnieuw wordt geladen
    setTimeout(() => {
      window.location.reload(true);
    }, 100); // 100ms delay
  };

  deleteRequest.onerror = (event) => {
    console.error("Error deleting database:", event.target.error);
  };
};

export const ResultCorrectAnswer = ({ question, answer }) => {
  const checkAnswers = (question, answer) => {
    if (question.__component === "quiz-game-types.stelling") {
      const correctAnswers = question.Antwoord_items.filter(
        (item) => item.is_correct_answer
      ).map((item) => item.id.toString());

      const allCorrect = answer.every((ans) =>
        correctAnswers.includes(ans.toString())
      );

      if (allCorrect) {
        return (
          <ResultCorrectAnswerStyle
            bgColor={question.theme_color}
            txtColor={question.theme_text_color}
          >
            <ResultScore
              score={true}
              scoreVisible={false}
              endTotalScore={false}
              startCalculation={false}
            />
            <ResultAnwserValidation validation="correct">
              <span>
                <i>👍️</i> Het antwoord is correct
              </span>
              <span>(1/1)</span>
            </ResultAnwserValidation>
          </ResultCorrectAnswerStyle>
        );
      } else {
        return (
          <>
            <ResultCorrectAnswerStyle
              bgColor={question.theme_color}
              txtColor={question.theme_text_color}
            >
              <ResultAnwserValidation validation="incorrect">
                <span>
                  <i>⛔️</i> Het antwoord is fout
                </span>
                <span>(0/1)</span>
              </ResultAnwserValidation>
            </ResultCorrectAnswerStyle>
            <QuizResultText Color="#69788c">
              Het juiste antwoord:
            </QuizResultText>
            <QuizResultText>
              <strong>
                {question.Antwoord_items.filter(
                  (item) => item.is_correct_answer === true
                ).map((item, index) => (
                  <ReactMarkdown key={index}>{item.content}</ReactMarkdown>
                ))}
              </strong>
            </QuizResultText>
          </>
        );
      }
    } else if (question.__component === "quiz-game-types.sorteer") {
      const correctOrder = question.sorteer_items.map((item) => item.id);
      const givenOrder = answer.map((item) => item.id);

      const allCorrect =
        JSON.stringify(correctOrder) === JSON.stringify(givenOrder);

      if (allCorrect) {
        return (
          <ResultCorrectAnswerStyle
            bgColor={question.theme_color}
            txtColor={question.theme_text_color}
          >
            <ResultScore
              score={true}
              scoreVisible={false}
              endTotalScore={false}
              startCalculation={false}
            />
            <ResultAnwserValidation validation="correct">
              <span>
                <i>👍️</i> Volgorde is correct
              </span>
              <span>(1/1)</span>
            </ResultAnwserValidation>
          </ResultCorrectAnswerStyle>
        );
      } else {
        return (
          <>
            <ResultCorrectAnswerStyle
              bgColor={question.theme_color}
              txtColor={question.theme_text_color}
            >
              <ResultAnwserValidation validation="incorrect">
                <span>
                  <i>⛔️</i> Volgorde is fout
                </span>
                <span>(0/1)</span>
              </ResultAnwserValidation>
            </ResultCorrectAnswerStyle>
            <QuizResultText Color="#69788c">
              Het juiste antwoord:
            </QuizResultText>
            <QuizResultOl>
              {question.sorteer_items.map((item) => (
                <li key={item.id}>
                  <QuizResultAnswer>
                    <ReactMarkdown>{item.content}</ReactMarkdown>
                  </QuizResultAnswer>
                </li>
              ))}
            </QuizResultOl>
          </>
        );
      }
    } else if (question.__component === "quiz-game-types.open-vragen") {
      const givenAnswer = answer;
      if (givenAnswer !== "") {
        return (
          <ResultCorrectAnswerStyle
            bgColor={question.theme_color}
            txtColor={question.theme_text_color}
          >
            <ResultScore
              score={true}
              scoreVisible={false}
              endTotalScore={false}
              startCalculation={false}
            />
            <ResultAnwserValidation validation="correct">
              <span>
                <i>👍️</i> Antwoord gegeven
              </span>
              <span>(1/1)</span>
            </ResultAnwserValidation>
          </ResultCorrectAnswerStyle>
        );
      } else {
        return (
          <ResultCorrectAnswerStyle
            bgColor={question.theme_color}
            txtColor={question.theme_text_color}
          >
            <ResultAnwserValidation validation="incorrect">
              <span>
                <i>🚫</i> Geen antwoord gegeven
              </span>
              <span>(0/1)</span>
            </ResultAnwserValidation>
          </ResultCorrectAnswerStyle>
        );
      }
    } else if (question.__component === "quiz-game-types.photo-upload") {
      const hasImg = answer && typeof answer === "object" && !!answer.dataUrl;

      if (hasImg) {
        return (
          <ResultCorrectAnswerStyle
            bgColor={question.theme_color}
            txtColor={question.theme_text_color}
          >
            <ResultScore
              score={true}
              scoreVisible={false}
              endTotalScore={false}
              startCalculation={false}
            />
            <ResultAnwserValidation validation="correct">
              <span>
                <i>👍️</i> Afbeelding geüpload
              </span>
              <span>(1/1)</span>
            </ResultAnwserValidation>
          </ResultCorrectAnswerStyle>
        );
      } else {
        return (
          <ResultCorrectAnswerStyle
            bgColor={question.theme_color}
            txtColor={question.theme_text_color}
          >
            <ResultAnwserValidation validation="incorrect">
              <span>
                <i>🚫</i> Geen afbeelding geüpload
              </span>
              <span>(0/1)</span>
            </ResultAnwserValidation>
          </ResultCorrectAnswerStyle>
        );
      }
    }

    return null;
  };

  const hasAnyAnswer =
    (Array.isArray(answer) && answer.length > 0) ||
    (typeof answer === "string" && answer !== "") ||
    (answer && typeof answer === "object"); // bv. upload-answer

  if (hasAnyAnswer) {
    return checkAnswers(question, answer);
  }

  return (
    <ResultCorrectAnswerStyle
      bgColor={question.theme_color}
      txtColor={question.theme_text_color}
    >
      <ResultAnwserValidation validation="incorrect">
        <span>
          <i>🚫</i> Er werd geen antwoord gegeven op deze vraag
        </span>
        <span>(0/1)</span>
      </ResultAnwserValidation>
    </ResultCorrectAnswerStyle>
  );
};

export const QuizSimpleResult = ({ question, answer }) => {
  const hasAnyAnswer =
    (Array.isArray(answer) && answer.length > 0) ||
    (typeof answer === "string" && answer.trim() !== "") ||
    (answer && typeof answer === "object"); // bv. upload-answer

  if (!hasAnyAnswer) return null;

  // Stelling: alleen +1 als alles correct is
  if (question.__component === "quiz-game-types.stelling") {
    const correctIds = question.Antwoord_items
      .filter((it) => it.is_correct_answer)
      .map((it) => it.id.toString());
    const given = (Array.isArray(answer) ? answer : [answer]).map(String);
    const allCorrect =
      correctIds.length === given.length &&
      correctIds.every((id) => given.includes(id));
    return allCorrect ? (
      <ResultScore score={true} scoreVisible={false} endTotalScore={false} startCalculation={false} />
    ) : null;
  }

  // Sorteer: alleen +1 als volgorde exact klopt
  if (question.__component === "quiz-game-types.sorteer") {
    const correctOrder = question.sorteer_items.map((it) => it.id);
    const givenOrder = (Array.isArray(answer) ? answer : []).map((it) => it.id);
    const allCorrect =
      JSON.stringify(correctOrder) === JSON.stringify(givenOrder);
    return allCorrect ? (
      <ResultScore score={true} scoreVisible={false} endTotalScore={false} startCalculation={false} />
    ) : null;
  }

  // Open vraag: +1 als er tekst is
  if (question.__component === "quiz-game-types.open-vragen") {
    const given = typeof answer === "string" ? answer.trim() : "";
    return given !== "" ? (
      <ResultScore score={true} scoreVisible={false} endTotalScore={false} startCalculation={false} />
    ) : null;
  }

  // ➜ Photo upload: +1 als er een image is
  if (question.__component === "quiz-game-types.photo-upload") {
    const hasImg = answer && typeof answer === "object" && !!answer.dataUrl;
    return hasImg ? (
      <ResultScore score={true} scoreVisible={false} endTotalScore={false} startCalculation={false} />
    ) : null;
  }

  return null;
};


export const WebpageItem = ({
  bgColor,
  txtColor,
  overViewPage,
  question,
  answer,
  attempt,
}) => {
  const renderAnswerContent = () => {
    if (question.__component === "quiz-game-types.stelling") {
      const selectedAnswers = answer
        .map((id) => {
          const answerItem = question.Antwoord_items.find(
            (item) => item.id === parseInt(id)
          );
          return answerItem ? answerItem.content : "";
        })
        .filter((content) => content)
        .join("\n\r ");
      return (
        <QuizResultDiv bgVisible={overViewPage}>
          <ResultTitle
            bgColor={question.theme_color}
            txtColor={question.theme_text_color}
          >
            {question.title}
          </ResultTitle>
          <QuizResultDivItem>
            <QuizResultItemInformation>
              Keuze vraag •{" "}
              <ResultPogingen
                attempts={attempt}
                maximum_attempts={question.maximum_attempts}
              />
            </QuizResultItemInformation>
            {question.result__pre_text && (
              <QuizResultText Color="#69788c">
                {question.result__pre_text}
              </QuizResultText>
            )}
            <QuizResultText>
              <QuizResultAnswer>
                <ReactMarkdown>{selectedAnswers}</ReactMarkdown>
              </QuizResultAnswer>
            </QuizResultText>

            {question.result__post_text && (
              <QuizResultText Color="#69788c">
                {question.result__post_text}
              </QuizResultText>
            )}

            <ResultCorrectAnswer question={question} answer={answer} />
          </QuizResultDivItem>
        </QuizResultDiv>
      );
    } else if (question.__component === "quiz-game-types.sorteer") {
      return (
        <QuizResultDiv bgVisible={overViewPage}>
          <ResultTitle
            bgColor={question.theme_color}
            txtColor={question.theme_text_color}
          >
            {question.title}
          </ResultTitle>
          <QuizResultDivItem>
            <QuizResultItemInformation>
              Sorteer vraag •{" "}
              <ResultPogingen
                attempts={attempt}
                maximum_attempts={question.maximum_attempts}
              />
            </QuizResultItemInformation>

            {question.result__pre_text && (
              <QuizResultText Color="#69788c">
                {question.result__pre_text}
              </QuizResultText>
            )}
            <QuizResultText>
              <QuizResultOl>
                {answer.map((item) => (
                  <li key={item.id}>
                    <QuizResultAnswer>{item.content}</QuizResultAnswer>
                  </li>
                ))}
              </QuizResultOl>
            </QuizResultText>
            {question.result__post_text && (
              <QuizResultText Color="#69788c">
                {question.result__post_text}
              </QuizResultText>
            )}
            <ResultCorrectAnswer question={question} answer={answer} />
          </QuizResultDivItem>
        </QuizResultDiv>
      );
    } else if (question.__component === "quiz-game-types.photo-upload") {
      const hasImg = answer && typeof answer === "object" && !!answer.dataUrl;

      return (
        <QuizResultDiv bgVisible={overViewPage}>
          <ResultTitle
            bgColor={question.theme_color}
            txtColor={question.theme_text_color}
          >
            {question.title}
          </ResultTitle>
          <QuizResultDivItem>
            <QuizResultItemInformation>
              Foto upload •{" "}
              <ResultPogingen
                attempts={attempt}
                maximum_attempts={0}
              />
            </QuizResultItemInformation>

            {question.result__pre_text && (
              <QuizResultText Color="#69788c">
                {question.result__pre_text}
              </QuizResultText>
            )}

            {hasImg ? (
              <QuizResultText>
                <img
                  src={answer.dataUrl}
                  alt="Geüploade afbeelding"
                  style={{ maxWidth: "100%", height: "auto" }}
                />
              </QuizResultText>
            ) : (
              <QuizResultText Color="#69788c">
                Geen afbeelding geüpload.
              </QuizResultText>
            )}

            {question.result__post_text && (
              <QuizResultText Color="#69788c">
                {question.result__post_text}
              </QuizResultText>
            )}

            <ResultCorrectAnswer question={question} answer={answer} />
          </QuizResultDivItem>
        </QuizResultDiv>
      );
    } else if (question.__component === "quiz-game-types.result-title") {
      return (
        <QuizResultDiv
          borderInVisible="true"
          bgVisible={overViewPage}
          style={{ flex: "100%" }}
        >
          <QuizResultDivItem>
            <h1 style={{ fontSize: `${question.title_size}em` }}>
              {question.title}
            </h1>
            <ReactMarkdown>{question.description}</ReactMarkdown>
          </QuizResultDivItem>
        </QuizResultDiv>
      );
    } else {
      return (
        <QuizResultDiv bgVisible={overViewPage}>
          <ResultTitle
            bgColor={question.theme_color}
            txtColor={question.theme_text_color}
          >
            {question.title}
          </ResultTitle>
          <QuizResultDivItem>
            <QuizResultItemInformation>
              Open vraag •{" "}
              <ResultPogingen
                attempts={attempt}
                maximum_attempts={question.maximum_attempts}
              />
            </QuizResultItemInformation>
            {question.result__pre_text && (
              <QuizResultText Color="#69788c">
                {question.result__pre_text}
              </QuizResultText>
            )}
            <QuizResultText>
              <QuizResultAnswer>{answer}</QuizResultAnswer>
            </QuizResultText>
            {question.result__post_text && (
              <QuizResultText Color="#69788c">
                {question.result__post_text}
              </QuizResultText>
            )}
            <ResultCorrectAnswer question={question} answer={answer} />
          </QuizResultDivItem>
        </QuizResultDiv>
      );
    }
  };

  return renderAnswerContent();
};

export const SimpleResultWebpageItem = ({
  bgColor,
  txtColor,
  overViewPage,
  question,
  answer,
  attempt,
}) => {
  const renderAnswerContent = () => {
    if (question.__component === "quiz-game-types.stelling") {
      // console.log('uitgevoerd',question,answer );
      // const selectedAnswers = answer
      //   .map((id) => {
      //     const answerItem = question.Antwoord_items.find(
      //       (item) => item.id === parseInt(id)
      //     );
      //     return answerItem ? answerItem.content : "";
      //   })
      //   .filter((content) => content)
      //   .join("\n\r ");
      const selectedAnswers = (Array.isArray(answer) ? answer : [answer])
        .map((id) => {
          const answerItem = question.Antwoord_items.find(
            (item) => item.id === parseInt(id)
          );
          return answerItem ? answerItem.content : "";
        })
        .filter((content) => content)
        .join("\n\r ");
      return <QuizSimpleResult question={question} answer={answer} />;
    } else if (question.__component === "quiz-game-types.sorteer") {
      return <QuizSimpleResult question={question} answer={answer} />;
    } else if (question.__component === "quiz-game-types.result-title") {
      return (
        <QuizResultDiv
          borderInVisible="true"
          bgVisible={overViewPage}
          style={{ flex: "100%" }}
        >
          <QuizResultDivItem>
            <h1 style={{ fontSize: `${question.title_size}em` }}>
              {question.title}
            </h1>
            <ReactMarkdown>{question.description}</ReactMarkdown>
          </QuizResultDivItem>
        </QuizResultDiv>
      );
    } else {
      return <QuizSimpleResult question={question} answer={answer} />;
    }
  };

  return renderAnswerContent();
};
